import { useCallback, useEffect, useMemo, useState } from 'react';

import { useAuth } from '../../../contexts/AuthContext';
import { checkChallengeLimit } from '../services/duelsService';

const DAILY_LIMIT = 4;

const getFallbackReset = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    return tomorrow;
};

const formatTimeUntil = (date) => {
    const target = date instanceof Date && !Number.isNaN(date.getTime()) ? date : getFallbackReset();
    const diff = Math.max(target.getTime() - Date.now(), 0);
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    return { hours, minutes, formatted: `${hours}h ${minutes}min` };
};

/**
 * Limite diario real vindo do Supabase.
 * O banco e a fonte de verdade, entao o valor fica correto entre aparelhos.
 */
export const useChallengeLimit = () => {
    const { user } = useAuth();
    const [limit, setLimit] = useState({
        remaining: DAILY_LIMIT,
        resetsAt: getFallbackReset(),
    });
    const [isLoading, setIsLoading] = useState(true);

    const refreshLimit = useCallback(async () => {
        if (!user?.id) {
            setLimit({ remaining: DAILY_LIMIT, resetsAt: getFallbackReset() });
            setIsLoading(false);
            return;
        }

        setIsLoading(true);
        const result = await checkChallengeLimit(user.id);
        setLimit({
            remaining: Math.max(0, Math.min(DAILY_LIMIT, result.remaining ?? DAILY_LIMIT)),
            resetsAt: result.resetsAt || getFallbackReset(),
        });
        setIsLoading(false);
    }, [user?.id]);

    useEffect(() => {
        refreshLimit();
    }, [refreshLimit]);

    const used = Math.max(0, DAILY_LIMIT - limit.remaining);

    const timeUntilReset = useMemo(
        () => formatTimeUntil(limit.resetsAt),
        [limit.resetsAt]
    );

    return {
        used,
        remaining: limit.remaining,
        isLimitReached: limit.remaining <= 0,
        incrementCount: refreshLimit,
        refreshLimit,
        timeUntilReset,
        isLoading,
    };
};

export default useChallengeLimit;
